<template>
    <nav class="comp-nav-menu is-fixed-top">
        <router-link to="/" class="comp-nav-home"><b-icon icon="home" class="darker" type="is-light" size="is-medium"></b-icon></router-link>
        <div v-if="done===true" class="comp-nav-item comp-nav-button" @click="togglecompnav" data-target="comp-nav-menu">
            <span v-if="selectedcomp">{{selectedcomp.name}}</span>
            <span v-else>{{headercomplabel}}</span>
            <b-icon icon="menu-down" size="is-medium" class="comp-down"></b-icon>
        </div>
        <div v-else class="comp-nav-item comp-nav-button">
            <span>&nbsp; <b-icon icon="loading" size="is-medium" class="comp-down"></b-icon></span>
        </div>
        <div class="comp-nav-item comp-shrink ">
            <router-link to="/comps/new" class="button is-primary">NEW Comp</router-link>
        </div>
        <a role="button" id="burger" @click="togglemenu" class="comp-nav-burger burger" aria-label="menu" aria-expanded="false" data-target="mainmenu">
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
        </a>

        <div class="mobile-menu dash" id="mainmenu">
            <nav class="mob-pad">
                <p class="mob-section">
                    <router-link v-if="isAuthenticated" to="/comps" class="button is-primary is-large is-fullwidth">
                        <strong>My Competitions</strong>
                    </router-link>
                    <router-link v-else to="/start" class="button is-primary is-large is-fullwidth">
                        <strong>Start for Free</strong>
                    </router-link>
                </p>
                <p class="mob-section">
                    <router-link v-if="!isAuthenticated" to="/login" class="mob-item is-large is-fullwidth">
                        Log In
                    </router-link>
                    <router-link v-for="link in links" :key="link.anchor" :to="link.href" :class="link.mobileclass">{{link.anchor}}</router-link>
                    <a role="button" v-if="isAuthenticated" @click="logout" class="mob-item is-large is-fullwidth">
                        Log out
                    </a>
                </p>
                <goto-box @pushroute="closemenu"></goto-box>
            </nav>
        </div>

        <div class="comp-list-menu" id="complistmenu">
            <div @click="navigate(comp)" v-for="comp in competitions" :key="comp.id" :value="comp">
                <div class="comp-list-item">
                    <div class="column is-two-thirds">
                        {{comp.name}}
                    </div>
                    <div class="column is-narrow">
                        {{comp.key}}
                    </div>
                </div>
            </div>
        </div>
    </nav>
</template>

<style>
.icon.darker.has-text-light {
    color: #ababab !important;
}
.norap { white-space: nowrap;}
.comp-list-menu.is-active {
    transform: translateY(0%); 
    transition: all 0.3s; 
    top: 3.25rem;
 
}
.comp-list-item {
    cursor: pointer;
    display: flex; 
    border-bottom: 1px solid #fff;
}
.comp-list-item:hover { background: #f7f7f7; }
.comp-list-menu { 
    transition: transform 0.3s;  
    transform: translateY(-100%);   
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    /* bottom: 0; */
    background: #ebebeb;
    padding: 3rem 1rem;
    height: calc(100vh - 3.25rem);
    overflow: auto;
}
.comp-nav-burger span:nth-child(1) {
    top: calc(50% - 6px);
}
.comp-nav-burger span:nth-child(2) {
    top: calc(50% - 1px);
}
.comp-nav-burger span:nth-child(3) {
    top: calc(50% + 4px);
}
.comp-nav-burger span {
    background-color: currentColor;
    display: block;
    height: 1px;
    left: calc(50% - 8px);
    position: absolute;
    transform-origin: center;
    transition-duration: 86ms;
    transition-property: background-color, opacity, transform;
    transition-timing-function: ease-out;
    width: 16px;
}
.comp-nav-home {
    cursor: pointer;
    display: flex;    
    justify-content: center;
    align-items: center;
    height: 3.25rem;
    position: relative;
    width: 3.25rem;
    z-index: 30;
    background: #fff;
}
.comp-nav-burger {
    cursor: pointer;
    display: block;
    height: 3.25rem;
    position: relative;
    width: 3.25rem;
    margin-left: auto;
    z-index: 30;
    background: #fff;
}
.comp-nav-burger:hover, .comp-nav-home:hover {
    background-color: rgba(0, 0, 0, 0.05);
}
.comp-nav-menu { 
    display: flex; align-items: center;    
    left: 0;
    position: fixed;
    right: 0;
    z-index: 30; 
    top:0;
}
.home-button { z-index: 30; }

.comp-nav-menu::before { content: ''; position: absolute; top:0; right:0;left:0; bottom:0; background: #FFF; z-index: 30;}
.comp-nav-item.comp-shrink { flex-grow: 0; }
.comp-down { position: absolute; right: 0; background: #fff; }
.comp-nav-button { border-right: 1px solid #ddd; cursor: pointer; white-space: nowrap; overflow:hidden; }
.comp-nav-item {
    align-items: center;
    display: flex;
    flex-grow: 1;
    padding: 0.5rem 1rem;
    position: relative;
    z-index: 30;
    background: #fff;
    cursor: pointer;
}
.comp-nav-burger.is-active span:nth-child(1) {
    -webkit-transform: translateY(5px) rotate(45deg);
    transform: translateY(5px) rotate(45deg);
}
.navbar-burger span:nth-child(1) {
    top: calc(50% - 6px);
}
.comp-nav-burger.is-active span:nth-child(2) {
    opacity: 0;
}
.comp-nav-burger span:nth-child(2) {
    top: calc(50% - 1px);
}
.comp-nav-burger.is-active span:nth-child(3) {
    -webkit-transform: translateY(-5px) rotate(-45deg);
    transform: translateY(-5px) rotate(-45deg);
}
.comp-nav-burger span:nth-child(3) {
    top: calc(50% + 4px);
}
#mainmenu.dash { top: 3.5rem; }
@media (min-width: 768px ){
    .comp-list-menu { padding: 3rem; }
}
</style>

<script>

import GotoBox from "../../home/GotoBox.vue";

export default {
    /*asyncData ({ store, context }) {
        //let origin = context ? context.origin : window.location.origin
        return store.dispatch('backend/get_user_competitions', origin)
              .then((x) => this.done = true)
    },*/
    data: function() {
        return {
            selectedname: null,
            selectedcomp: null,
            done: false,
            links: []
        }
    },
    mounted() {
        this.$store.dispatch('backend/get_user_competitions', origin)
        .then(() =>  this.done = true)
        .then(() => this.getcompetition(this.$route.params.competitionid))
    },
    name: 'DashHeader', 
    components: {
        GotoBox
    },
    watch: {
        "$route.params.competitionid": function(id) { 
            this.getcompetition(id)
         },
    
        competition: function(nv) {
            if(typeof nv != 'undefined')
                this.selectedname = nv.name
        }
    },
    computed: {
        headercomplabel() {
            
            return !this.competitions || (this.competitions && this.competitions.length == 0) ? 'No Competitions Yet...' : 'Your Competitions'
        },
        competition() { return this.$store.getters['backend/competition']; },
        competitions() { return this.$store.getters['backend/competitions']; },
        isAuthenticated() {
            return this.$store.getters['account/isAuthenticated'];
        }
    },
    methods: {
        getcompetition(id) {
            if(id)
            this.$store.dispatch('backend/get_user_competition', id)
            .then(() => {
                this.selectedcomp = this.competition
                this.done = true
            })
        },
        navigate(ob) {
            this.togglecompnav()
            let comp = ob
            //if(comp.length)
            this.selectedcomp = comp
            this.$router.push(`/comps/${ob.id}`)
        },
        logout() {
            this.$store.dispatch("account/logout").then(() => {
                this.$router.push("/"); 
            });
            this.closemenu()
        },
        togglecompnav() {
            if (this.competitions && this.competitions.length) {
                let m = document.getElementById('complistmenu')
                m.classList.toggle('is-active')
            }
            this.closemenu()
        },
        closemenu() {
            let el = document.getElementById('burger'), menu = document.getElementById(el.dataset.target)
            el.classList.remove('is-active');
            menu.classList.remove('is-active');
        },
        togglemenu(x) {
            let el = x.currentTarget, menu = document.getElementById(el.dataset.target)
            el.classList.toggle('is-active');
            menu.classList.toggle('is-active');
        },
    }
}
</script>


